export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1770_.7b204ec2.jpg";